export const ACKNOWLEDGEMENT_REQUIRED = 'acknowledgement_required';
export const DRAFT_CHANGED = 'draft_changed';